import types from "resources/types";
import { createResourceDetailQuery } from "queries";

export const agencyQuery = (config = {}) =>
  createResourceDetailQuery(types.AGENCY, {
    url: "/api/v2/hiring_agencies/self/",
    ...config,
  });
